<script setup lang="ts">
import { Card, CardContent } from '@/components/ui/card';
</script>

<template>
  <Card class="shadow-none">
    <CardContent>
      <div class="p-6">
        <h1>Loading...</h1>
      </div>
    </CardContent>
  </Card>
</template>
